import React from 'react';
import { useUploadStore } from '../../stores/uploadStore';
import styles from './UploadProgressToast.module.css';
import CloseIcon from '@mui/icons-material/Close';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const UploadProgressToast: React.FC = () => {
  const tasks = useUploadStore(state => state.tasks);
  const dismissTask = useUploadStore(state => state.dismissTask);

  const activeTasks = Object.values(tasks);
  if (activeTasks.length === 0) return null;

  return (
    <div className={styles.container}>
      {activeTasks.map(task => {
        const progress = Math.round((task.uploadedFiles / task.totalFiles) * 100) || 0;
        const isCompleted = task.status === 'completed';
        const isError = task.status === 'error';

        return (
          <div key={task.complaintId} className={`${styles.toast} ${isCompleted ? styles.completed : isError ? styles.error : ''}`}>
            <div className={styles.iconContainer}>
               {isCompleted ? <CheckCircleIcon className={styles.successIcon} /> : isError ? <ErrorOutlineIcon className={styles.errorIcon} /> : <CloudUploadIcon className={styles.uploadIcon} />}
            </div>
            <div className={styles.content}>
               <div className={styles.header}>
                 <span className={styles.title}>
                   {isCompleted ? 'Envio Concluído' : isError ? 'Erro no envio' : 'Enviando imagens...'}
                 </span>
                 <button onClick={() => dismissTask(task.complaintId)} className={styles.closeBtn}>
                   <CloseIcon fontSize="small" />
                 </button>
               </div>
               
               {task.status === 'uploading' && (
                 <>
                   <div className={styles.progressText}>
                     {task.uploadedFiles} de {task.totalFiles} arquivo(s) enviados
                   </div>
                   <div className={styles.progressBarBg}>
                     <div className={styles.progressBarFill} style={{ width: `${progress}%` }} />
                   </div>
                 </>
               )}
               
               {isError && (
                 <div className={styles.errorMessage}>
                   {task.errorMessage}
                 </div>
               )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default UploadProgressToast;
